import dynamic, { DynamicOptions } from 'next/dynamic'
import { LivestreamCtaButtonProps } from '@/organisms/Livestream/LivestreamCtaButton/types'
import { logger } from '@/utils/logging'

export const LivestreamCtaButton = dynamic(
  import('./LivestreamCtaButton')
    .then((mod) => mod.LivestreamCtaButton)
    .catch((err) =>
      logger().error('Failed to load the LivestreamCtaButton!', err),
    ) as DynamicOptions<LivestreamCtaButtonProps>,
  {
    ssr: false,
  },
)
